import { LEGACY_TENANT_SLUGS } from '../api/types';

/**
 * Does this tenant have a Customers area?
 *
 * Organizations and customer accounts are **operational-only** models. The
 * endpoints behind the screens say so themselves: `customerAccountController`
 * and `organizationController` answer 409 *"only available for self-service
 * tenants"* when the tenant's Prisma client has no `account` model, which is
 * precisely the legacy per-tenant databases. This mirrors that line rather than
 * inventing a second one — a sidebar entry that leads to a wall of 409s is
 * worse than no entry.
 *
 * It used to be `selectedTenant === 'demo'`, from when the endpoints did not
 * exist and demo was the preview surface. `demo` was never special: it is an
 * operational tenant like any other, and it is still covered here.
 *
 * One definition, used by the sidebar entry and by the route guard, because a
 * nav item you can see and a page you can open must agree — the pages are
 * reachable by URL whether or not the entry is rendered.
 */
export const canSeeCustomersArea = (tenantSlug: string | null | undefined): boolean =>
    !!tenantSlug && !LEGACY_TENANT_SLUGS.has(tenantSlug);
